import React, { useEffect, useRef } from "react";
import $ from "jquery";
import moment from "moment";
import "daterangepicker";
import "daterangepicker/daterangepicker.css";

const CommonDateRangePicker = ({ label = "Select Date Range", onChange, defaultStart, defaultEnd }) => {

    const inputRef = useRef(null);

    useEffect(() => {
        const $input = $(inputRef.current);

        // Initialize daterangepicker
        $input.daterangepicker(
            {
                opens: "right",
                autoUpdateInput: true,
                locale: {
                    format: "MMM D, YYYY",
                    cancelLabel: "Clear",
                },
                startDate: defaultStart || moment().startOf("month"),
                endDate: defaultEnd || moment().endOf("month"),
            },
            function (start, end) {
                // Send range to parent via prop
                if (onChange) {
                    onChange({
                        startDate: start.format("YYYY-MM-DD"),
                        endDate: end.format("YYYY-MM-DD"),
                    });
                }
            }
        );

        // Cleanup on unmount
        return () => {
            if ($input.data("daterangepicker")) {
                $input.data("daterangepicker").remove();
            }
        };
    }, [onChange, defaultStart, defaultEnd]);

    return (
        <div>
            {label && (
                <label htmlFor="dateRangeInput" className="form-label">
                    {label}
                </label>
            )}
            <input
                id="dateRangeInput"
                ref={inputRef}
                type="text"
                className="form-control"
                style={{ cursor: "pointer" }}
            />
        </div>
    )
}

export default CommonDateRangePicker